import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { baseApiUrl } from "../../../services/api";
import { useNavigate } from "react-router-dom";

// Définition des couleurs du thème
const colors = {
    primary: "#ff8c00", // Orange
    secondary: "#ffcc00", // Jaune
    tertiary: "#4CAF50", // Vert
    light: "#f9f9f9",
    dark: "#333333",
    text: "#555555",
    border: "#eeeeee"
};

function DetailProjet() {
  const [project, setProject] = useState(null);
  const { projectId } = useParams();
  const [recentProjects, setRecentProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (projectId) {
      console.log("Fetching project with ID:", projectId);
      baseApiUrl
        .get(`/projet/${projectId}`)
        .then((response) => {
          console.log("Project fetched:", response.data);
          setProject(response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération du projet :", error);
        });
    } else {
      console.error("L'ID du projet est introuvable !");
    }
  }, [projectId]);

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, "dd MMMM yyyy", { locale: fr }); // Format : 13 octobre 2024
    } catch {
      return "Date invalide";
    }
  };

  // Fonction pour calculer le temps de lecture (basée sur 200 mots par minute)
  const calculateReadingTime = (text) => {
    if (!text) return 1; // Temps de lecture minimum
    const words = text.trim().split(/\s+/).length;
    const minutes = Math.ceil(words / 200);
    return minutes;
  };

  useEffect(() => {
    console.log("Fetching all projects...");
    setLoading(true);
    baseApiUrl
      .get("/projet/liste")
      .then((response) => {
        console.log("Projects fetched:", response.data);

        // Filtrer les projets actifs
        const activeProjects = response.data.filter(proj => proj.actif === true);

        // Sauvegarder tous les projets pour la recherche
        setAllProjects(activeProjects);

        // Filtrer pour exclure le projet actuel et trier par date (plus récente d'abord)
        const otherRecentProjects = activeProjects
          .filter(proj => proj.id !== parseInt(projectId))
          .sort((a, b) => new Date(b.created) - new Date(a.created))
          .slice(0, 5); // Obtenir seulement les 5 plus récents

        setRecentProjects(otherRecentProjects);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des projets :", error);
        setRecentProjects([]);
        setAllProjects([]);
        setLoading(false);
      });
  }, [projectId]);

  // Gérer la recherche
  const handleSearch = (event) => {
    event.preventDefault();
    if (searchTerm.trim()) {
      const results = allProjects.filter(proj =>
        proj.titre && proj.titre.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setSearchResults(results);
      setShowSearchResults(true);
    } else {
      setSearchResults([]);
      setShowSearchResults(false);
    }
  };

  // Fonction pour tronquer le texte pour les aperçus
  const truncateText = (text, maxLength) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substr(0, maxLength) + "...";
  };

  // Navigation vers un autre projet
  const navigateToProject = (id) => {
    navigate(`/projet/${id}`);
    window.scrollTo(0, 0); // Défiler vers le haut pour une meilleure expérience utilisateur
    setShowSearchResults(false); // Cacher les résultats de recherche après navigation
    setSearchTerm(""); // Réinitialiser le terme de recherche
  };

  if (!project) return (
    <div className="loading-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <p>Chargement des projets...</p>
    </div>
  );

  // Calcul du temps de lecture pour l'article actuel
  const readingTime = calculateReadingTime(
    [
      project.descriptionTechnique,
      project.origineMission,
      project.caractereInnovant,
      project.besoinExpose,
      project.critereReussite,
      project.besoinsEventuels,
      project.moyensPourReussir
    ].filter(Boolean).join(" ")
  );

  return (
    <detail>
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">
                <h1 style={{ color: colors.tertiary }}>Détails du projet</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-details1-all sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row align-items-center">
                <div className="col-lg-8 m-auto">
                  <div className="blog-page3-single-box">
                    <div className="heading1">
                      <div className="social-area">
                        <div className="author-area" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "15px", marginBottom: "20px" }}>
                          <div className="author" style={{ display: "flex", alignItems: "center" }}>
                            <div className="author-tumb" style={{ marginRight: "10px" }}>
                              <img
                                src={
                                  project.utilisateur && project.utilisateur.photo
                                    ? baseApiUrl.defaults.baseURL + `/image/${project.utilisateur.photo}`
                                    : "https://via.placeholder.com/30"
                                }
                                alt="Auteur"
                                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                              />
                            </div>
                            <div>
                              <a href="#" className="author-text" style={{ display: "block", fontWeight: "600" }}>
                                {project.utilisateur
                                  ? project.utilisateur.nom
                                  : "Auteur inconnu"}
                              </a>
                              {project.utilisateur && project.utilisateur.siteWeb && (
                                <a
                                  href={project.utilisateur.siteWeb}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontSize: "14px", color: colors.tertiary }}
                                >
                                  {project.utilisateur.siteWeb}
                                </a>
                              )}
                            </div>
                          </div>
                          <div className="date" style={{ display: "flex", alignItems: "center" }}>
                            <a href="#" style={{ display: "flex", alignItems: "center", color: "#666" }}>
                              <img
                                src="assets/img/icons/date1.svg"
                                alt="Date"
                                style={{ marginRight: "5px", width: "16px" }}
                              />
                              {formatDate(project.created)}
                            </a>
                          </div>
                        </div>
                        <a href="#" className="time mt-16" style={{ display: "inline-flex", alignItems: "center", color: "#666" }}>
                          <img src="assets/img/icons/time1.svg" alt="Temps de lecture" style={{ marginRight: "5px", width: "16px" }} />
                          {readingTime} min
                        </a>
                      </div>
                      <h2 style={{ marginTop: "20px", marginBottom: "20px", fontWeight: "700", color: colors.primary }}>{project.titre}</h2>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="thumbnail image-anime _relative mt-20">
                    <img
                      className="w-full"
                      src={baseApiUrl.defaults.baseURL + `/image/${project.image}`}
                      alt="Projet"
                      style={{
                        width: "100%",
                        height: "450px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        boxShadow: `0 5px 15px rgba(0,0,0,0.1)`
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginTop: "50px" }}>
            <div className="col-lg-8">
              <div className="details content-area">
                {project.descriptionTechnique && (
                  <article className="project-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.primary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Description technique</h3>
                      <p style={{ lineHeight: "1.7", color: colors.text }}>{project.descriptionTechnique}</p>
                    </div>
                  </article>
                )}

                {project.origineMission && (
                  <article className="project-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.secondary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Origine de la mission</h3>
                      <p style={{ lineHeight: "1.7", color: colors.text }}>{project.origineMission}</p>
                    </div>
                  </article>
                )}

                {project.caractereInnovant && (
                  <article className="project-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.tertiary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Caractère innovant</h3>
                      <p style={{ lineHeight: "1.7", color: colors.text }}>{project.caractereInnovant}</p>
                    </div>
                  </article>
                )}

                {project.besoinExpose && (
                  <article className="project-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.primary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Besoins exposés</h3>
                      <p style={{ lineHeight: "1.7", color: colors.text }}>{project.besoinExpose}</p>
                    </div>
                  </article>
                )}

                {project.critereReussite && (
                  <article className="project-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.secondary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Critères de réussite</h3>
                      <p style={{ lineHeight: "1.7", color: colors.text }}>{project.critereReussite}</p>
                    </div>
                  </article>
                )}

                {project.besoinsEventuels && (
                  <article className="project-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.tertiary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Besoins éventuels</h3>
                      <p style={{ lineHeight: "1.7", color: colors.text }}>{project.besoinsEventuels}</p>
                    </div>
                  </article>
                )}

                {project.moyensPourReussir && (
                  <article className="project-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.primary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Moyens pour réussir</h3>
                      <p style={{ lineHeight: "1.7", color: colors.text }}>{project.moyensPourReussir}</p>
                    </div>
                  </article>
                )}

                {project.video && (
                  <article className="project-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.secondary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Version vidéo du projet</h3>
                      <div className="video-container mt-3">
                        {project.video.includes("youtube.com") || project.video.includes("youtu.be") ? (
                          <iframe
                            className="w-full"
                            width="100%"
                            height="315"
                            src={project.video.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{ borderRadius: "8px" }}
                          ></iframe>
                        ) : (
                          <video
                            className="w-full"
                            controls
                            style={{ borderRadius: "8px" }}
                          >
                            <source src={baseApiUrl.defaults.baseURL + `/image/${project.video}`} type="video/mp4"/>
                            Your browser does not support the video tag.
                          </video>
                        )}
                      </div>
                    </div>
                  </article>
                )}
              </div>
            </div>

            <div className="col-lg-4">
              <div className="blog1-sidebar-area mt-40 ml-30 sm:ml-0 md:ml-0 md:mt-30 sm:mt-30">
                <div className="sidebar-details-widget_1 _search-area1">
                  <h3 style={{ color: colors.primary }}>Rechercher</h3>
                  <form onSubmit={handleSearch}>
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Rechercher..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          borderColor: colors.border,
                          padding: "10px 40px 10px 15px",
                          borderRadius: "5px",
                          width: "100%"
                        }}
                      />
                      <button
                        type="submit"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: colors.primary
                        }}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </form>

                  {/* Résultats de recherche */}
                  {showSearchResults && (
                    <div style={{
                      marginTop: "15px",
                      border: `1px solid ${colors.border}`,
                      borderRadius: "5px",
                      padding: "15px",
                      backgroundColor: colors.light
                    }}>
                      <h4 style={{ color: colors.tertiary, marginBottom: "10px" }}>
                        Résultats de recherche ({searchResults.length})
                      </h4>

                      {searchResults.length === 0 ? (
                        <p>Aucun projet trouvé.</p>
                      ) : (
                        searchResults.map((result) => (
                          <div
                            key={result.id}
                            style={{
                              padding: "10px",
                              marginBottom: "10px",
                              borderBottom: `1px solid ${colors.border}`,
                              cursor: "pointer"
                            }}
                            onClick={() => navigateToProject(result.id)}
                          >
                            <h5 style={{
                              fontSize: "15px",
                              fontWeight: "600",
                              color: colors.primary,
                              marginBottom: "5px"
                            }}>
                              {truncateText(result.titre, 50)}
                            </h5>
                            <div style={{ display: "flex", alignItems: "center", fontSize: "12px", color: "#666" }}>
                              <i className="fa fa-calendar" style={{ marginRight: "5px" }}></i>
                              {formatDate(result.created)}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>

                <div className="sidebar-widget_1 _recent-posts mt-40">
                  <h3 style={{ color: colors.primary }}>Projets Récents</h3>

                  {loading ? (
                    <p>Chargement des projets récents...</p>
                  ) : recentProjects.length === 0 ? (
                    <p>Aucun autre projet disponible.</p>
                  ) : (
                    recentProjects.map((recentProj) => (
                      <div
                        className="blog1-recent-box mt-16"
                        key={recentProj.id}
                        style={{
                          display: "flex",
                          marginBottom: "20px",
                          borderBottom: `1px solid ${colors.border}`,
                          paddingBottom: "15px",
                          cursor: "pointer",
                          transition: "transform 0.3s ease",
                          ':hover': {
                            transform: "translateY(-3px)"
                          }
                        }}
                        onClick={() => navigateToProject(recentProj.id)}
                      >
                        <div className="recent-thumb" style={{ width: "80px", height: "80px", marginRight: "15px", flexShrink: 0 }}>
                          <img
                            src={recentProj.image ? baseApiUrl.defaults.baseURL + `/image/${recentProj.image}` : "default-image.jpg"}
                            alt={recentProj.titre || "Titre inconnu"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "5px",
                              border: `2px solid ${colors.secondary}`
                            }}
                          />
                        </div>
                        <div className="heading">
                          <span className="date" style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center" }}>
                            <img src="assets/img/icons/date1.svg" alt="date" style={{ width: "14px", marginRight: "5px" }} />
                            {formatDate(recentProj.created)}
                          </span>
                          <h5 style={{ fontSize: "15px", fontWeight: "600", marginTop: "5px", color: colors.tertiary }}>
                            {truncateText(recentProj.titre, 60)}
                          </h5>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer1 />
      <Footer />
    </detail>
  );
}

export default DetailProjet;
